import { render } from "./ad-post.vue?vue&type=template&id=27d57b66&scoped=true"
import script from "./ad-post.vue?vue&type=script&lang=js"
export * from "./ad-post.vue?vue&type=script&lang=js"

import "./ad-post.vue?vue&type=style&index=0&id=27d57b66&lang=scss"
import "./ad-post.vue?vue&type=style&index=1&id=27d57b66&scoped=true&lang=scss"
import "./ad-post.vue?vue&type=style&index=2&id=27d57b66&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d57b66"]])

export default __exports__